define('viewmodels/templates',[], function () {
    return {
        "iframeUrl": "http://shameen.info/templates/"
    };
});
